export class DemandPrice implements IDemandPrice {
    currency = 'EUR';
    grossPrice = 0;
    netPrice = 0;
    tax: IDemandPriceTaxEntry[] = [];

    public static fromDto(dto: IDemandPrice): DemandPrice {
        const price = new DemandPrice();
        Object.assign(price, dto);

        return price;
    }
}

export interface IDemandPriceTaxEntry {
    rate: number;
    amount: number;
}

export interface IDemandPrice {
    netPrice: number;
    grossPrice: number;
    currency: string;
    tax: IDemandPriceTaxEntry[];
}
